import type { ReactNode } from 'react';

export function Render(props: {
  when: boolean;
  children: ReactNode;
}): ReactNode {
  if (props.when) {
    return props.children;
  } else {
    return null;
  }
}
